import { render, staticRenderFns } from "./addCourseManage.vue?vue&type=template&id=72a3818e&scoped=true"
import script from "./addCourseManage.vue?vue&type=script&lang=js"
export * from "./addCourseManage.vue?vue&type=script&lang=js"
import style0 from "./addCourseManage.vue?vue&type=style&index=0&id=72a3818e&prod&lang=less"
import style1 from "./addCourseManage.vue?vue&type=style&index=1&id=72a3818e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a3818e",
  null
  
)

export default component.exports